class SidebarNavigation {
    constructor() {
        this.sidebar = document.querySelector(".sidebar-navigation");
        this.sidebarSubmenus = document.querySelectorAll(".sidebar-navigation .wp-block-navigation-submenu");
        this.openOnClick = document.querySelectorAll(".sidebar-navigation .open-on-hover-click");
        this.submenuIcons = document.querySelectorAll(".sidebar-navigation .wp-block-navigation__submenu-icon");
        this.events();
    }

    events() {
        if (this.sidebar) {
            // Whenever an instance of this.sidebarSubmenus gets the "show" class, remove it from all the other instances
            this.sidebarSubmenus.forEach((submenu) => {
                submenu.addEventListener("click", () => {
                    this.sidebarSubmenus.forEach((otherSubmenu) => {
                        if (otherSubmenu !== submenu) {
                            otherSubmenu.classList.remove("show");
                            otherSubmenu.firstElementChild.setAttribute('aria-expanded', 'false');
                        }
                    });
                });
            });

            // When an instance of this.submeßnuIcons is clicked, toggle the "show" class on its parent and expand or collapse the submenu
            this.submenuIcons.forEach((icon) => {
                icon.addEventListener("click", () => {
                    let previousSibling = icon.previousElementSibling;
                    icon.parentElement.classList.toggle("show");
                    if (previousSibling.getAttribute('aria-expanded') === 'true') {
                        previousSibling.setAttribute('aria-expanded', 'false');
                    } else {
                        previousSibling.setAttribute('aria-expanded', 'true');
                    }
                    // Toggle the 'open' class on the icon
                    icon.classList.toggle("open");
                });
            });

            // Find all the elements with .open-on-hover-click and replace that class with .open-on-click
            this.openOnClick.forEach((element) => {
                element.classList.replace("open-on-hover-click", "open-on-click");
            }
            );
            

        }
    }
}

export default SidebarNavigation;